import type { ReactNode } from 'react';
import type { MerchantDetails } from '../../types';
import { MerchantInformationPlaceholder } from '../../placeholders';
import styles from './merchant-information.module.css';

interface MerchantInformationProps {
  merchant: MerchantDetails;
}

export function MerchantInformation({ merchant }: MerchantInformationProps): ReactNode {
  const address = merchant.address;

  const dotSeparator = '·';
  const fullAddress =
    `${address.streetAddress}, ${address.zipCode} ${address.city}, ${address.countryCode}`.trim();

  return (
    <MerchantInformationPlaceholder>
      <p className="body-3" data-testid="pdf-preview-merchant-info-name">
        <span data-testid="pdf-preview-merchant-legal-name">{merchant.legalName}</span>
        <span className={styles.separator}>{dotSeparator}</span>
        <span data-testid="pdf-preview-merchant-info-address">{fullAddress}</span>
      </p>
    </MerchantInformationPlaceholder>
  );
}
